<template>
  <div>
    <div v-if="loading == false">
      <table
        v-if="duplicatedLeads.length > 1"
        class="uk-table journal-table uk-table-hover heightoverflow uk-table-middle uk-table-divider"
      >
        <tr>
          <th>LEAD ID</th>
          <th>AD SOYAD</th>
          <th>TEMSİLCİ</th>
          <th>OLUŞTURULMA TARİHİ</th>
        </tr>
        <tr v-for="dlead in duplicatedLeads" v-if="dlead.id !== id">
          <td>
            <a :href="'/leadDetail/' + dlead.id">
              <span class="green-button inline-flex">#{{ dlead.id }}</span>
            </a>
          </td>
          <td>{{ dlead.name }}</td>
          <td>{{ $root.getVal(15, dlead.agent_id) }}</td>
          <td>{{ dlead.created_at }}</td>
        </tr>
      </table>

      <div v-else class="flex items-center justify-center flex-col ">
        <svg height="140" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m24 18.854.024 13.27a4.12 4.12 0 0 0 1.88 3.478l12.138 7.772a3.968 3.968 0 0 0 3.893.217l11.692-5.77a4.107 4.107 0 0 0 2.27-3.675l-.024-13.27a4.12 4.12 0 0 0-1.88-3.478L41.854 9.626a3.968 3.968 0 0 0-3.894-.217l-6.287 3.1-5.409 2.67c-1.382.681-2.26 2.108-2.265 3.67v.005Z"
            stroke="#E16741"
            stroke-width="0.5"
            stroke-miterlimit="10"
          ></path>
          <path
            opacity="0.4"
            d="m40.848 37.55.024-8.975c.014-1.07.627-2.056 1.572-2.52l5.029-2.481 1.087-.537 2.066-1.02 1.904-.939a.885.885 0 0 1 .883.049.922.922 0 0 1 .428.788l.014 6.553-.01-.01.01 4.924c0 1.064-.618 2.06-1.563 2.524l-9.288 4.58.01-.014-.789.392c-.413.203-.779.019-.92-.068-.139-.087-.462-.343-.457-.813v-2.447.015Z"
            stroke="#E16741"
            stroke-width="0.5"
            stroke-miterlimit="10"
          ></path>
          <path
            d="M63.5 113h11a2 2 0 0 0 2-2V72a2 2 0 0 1 2-2H95"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linejoin="round"
            stroke-dasharray="4 4"
          ></path>
          <path
            d="M63.5 27h11a2 2 0 0 1 2 2v39a2 2 0 0 0 2 2H95"
            stroke="#E16741"
            stroke-width="0.5"
            stroke-linejoin="round"
            stroke-dasharray="4 4"
          ></path>

          <rect
            x="26"
            y="99"
            width="28"
            height="28"
            rx="6"
            stroke="#BCC3CE"
            stroke-width="0.5"
            stroke-linecap="round"
            stroke-dasharray="4 4"
          ></rect>

          <g filter="url(#a)" transform="rotate(-90 107 92)">
            <rect
              x="107"
              y="92"
              width="48"
              height="48"
              rx="9"
              fill="#FFFFFF"
            ></rect>
            <rect
              x="107"
              y="92"
              width="48"
              height="48"
              rx="9"
              stroke="#E16741"
              stroke-width="0.75"
            ></rect>
          </g>
          <rect
            opacity="0.4"
            x="112"
            y="87"
            width="38"
            height="38"
            rx="6"
            transform="rotate(-90 112 87)"
            stroke="#E16741"
            stroke-width="0.75"
          ></rect>
          <path
            d="M125 65.801v4.398c0 1.68 0 2.521.327 3.163a3.004 3.004 0 0 0 1.311 1.311c.642.327 1.482.327 3.162.327h2.4c1.68 0 2.52 0 3.162-.327a3.004 3.004 0 0 0 1.311-1.311C137 72.72 137 71.88 137 70.2v0-4.4c0-1.68 0-2.52-.327-3.162a3.004 3.004 0 0 0-1.311-1.311C134.72 61 133.88 61 132.2 61h-2.4c-1.68 0-2.52 0-3.162.327a3.005 3.005 0 0 0-1.311 1.311C125 63.28 125 64.12 125 65.801h0ZM128 64h4M130 67h4"
            stroke="#E16741"
            stroke-width="0.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M132.5 75v-2c0-.466 0-.699-.076-.883a1.001 1.001 0 0 0-.541-.54c-.184-.077-.417-.077-.883-.077s-.699 0-.883.076a1.001 1.001 0 0 0-.541.541c-.076.184-.076.417-.076.883v2"
            stroke="#E16741"
            stroke-width="0.8"
            stroke-linejoin="round"
          ></path>
        </svg>

        <span class="text-lg font-semibold text-black"
          >Eşleşen kayıt bulunamadı</span
        >
        <span class="text-sm font-light text-gray-400"
          >Aynı telefon numarasına ait başka bir kayıt daha önce eklenmiş
          olsaydı eğer burada gözükecekti.</span
        >
      </div>
    </div>
    <div v-else class="center">
      <vk-spinner ratio="2"></vk-spinner>
    </div>
  </div>
</template>

<script>
import httpService from "../../../services/http";
export default {
  data() {
    return {
      duplicatedLeads: [],
      loading: true
    };
  },
  props: ["id"],
  mounted() {
    this.getDublicated();
  },
  methods: {
    getDublicated() {
      httpService.dublicatedLeads({ id: this.id }).then(response => {
        this.duplicatedLeads = response.data.results;
        this.loading = false;
      });
    }
  }
};
</script>
